import { Record as record } from 'immutable';

import { construct, fields, resolve, resolveAll } from '../../helpers/LinkMapper';
import Station from '../Station';
import STicketScan from './STicketScan';

const defaults = {
    id: null,
    brand: null,
    createdDate: null,
    destination: new Station(),
    orderId: null,
    origin: new Station(),
    scans: [],
    subUtn: null,
    ticketId: null,
    ticketNumber: null,
    ticketTypeCode: null,
    utn: null,
    validTo: null,
};

export default class STicketCoupon extends record(defaults) {
    static fromJSON(json = {}) {
        return construct(STicketCoupon, json, {
            id: fields.string,
            brand: fields.string,
            createdDate: fields.datetime,
            destination: resolve.as(Station),
            orderId: fields.string,
            origin: resolve.as(Station),
            scans: resolveAll.as(STicketScan),
            subUtn: fields.string,
            ticketId: fields.string,
            ticketNumber: fields.string,
            ticketTypeCode: fields.string,
            utn: fields.string,
            validTo: fields.datetime,
        });
    }
}



// WEBPACK FOOTER //
// ./src/records/sticket/STicketCoupon.js